<template>
  <div @click="close" class="modal-question-form" id="modal-question-form">
    <div class="modal-question-form-overlay">
      <div class="modal-question-form-content">

        <div @click="(e) => e.stopPropagation()" :class="formSource === 'demo' ? 'modal-question-form-body' : 'modal-question-form-body--question'">
          <button @click="close" class="modal-question-form-close">
            <img src="@/assets/img/X_close.svg" alt="close-icon" />
          </button>

          <div class="modal-question-form-banner-wrapper">
            <div :class="formSource === 'demo' ? 'modal-question-form-banner' : 'modal-question-form-banner--question'">
              <h1 class="title title--gray" v-text="formSource === 'demo' ? translations[lang].title : translations[lang].titleQuestion" />
              <p class="subtitle" v-html="formSource === 'demo' ? translations[lang].subtitle : translations[lang].subtitleQuestion" />
            </div>
            <img v-if="formSource === 'demo'" src="@/assets/img/introduction/plan.webp" alt="banner">
          </div>

          <form id="modal-question-form" action="none" novalidate>
            <div :class="formSource === 'demo' ? 'modal-question-form__inputs' : 'modal-question-form__inputs--question'">

              <label class="styled-input" :class="{ 'has-text': activeField === 'name', 'styled-input--error': errorMessage.name }">
                <div class="styled-input__container">
                  <img src="@/assets/img/question-form/name-icon.svg" alt="mail-icon" />
                  <input @input="clearError('name')" @focus="activeField = 'name'"
                    @blur="activeField = null" :placeholder="translations[lang].name_placeholder" type="name" name="name" v-model="name" data-question-form="name" />
                </div>

                <p v-if="errorMessage.name" class="styled-input__error-text">{{ errorMessage.name[0] }}</p>
              </label>

              <label class="styled-input" :class="{ 'has-text': activeField === 'email', 'styled-input--error': errorMessage.email }">
                <div class="styled-input__container">
                  <img src="@/assets/img/question-form/email-icon.svg" alt="mail-icon" />
                  <input @input="clearError('email')" @focus="activeField = 'email'"
                    @blur="activeField = null" :placeholder="translations[lang].email_placeholder" type="email" name="email" v-model="email" data-question-form="email" />
                </div>

                <p v-if="errorMessage.email" class="styled-input__error-text">{{ errorMessage.email[0] }}</p>
              </label>

              <label v-if="formSource === 'demo'" class="styled-input" :class="{ 'has-text': activeField === 'companyUrl' }">
                <div class="styled-input__container">
                  <img src="@/assets/img/question-form/web-icon.svg" alt="mail-icon" />
                  <input @input="clearError('company_website')" @focus="activeField = 'companyUrl'"
                    @blur="activeField = null" :placeholder="translations[lang].companyUrl_placeholder" type="companyUrl" name="companyUrl" v-model="companyUrl" data-question-form="companyUrl" />
                </div>
              </label>

              <label v-if="formSource === 'demo'" class="styled-input" :class="{ 'has-text': activeField === 'plansСount' }">
                <div class="styled-input__container">
                  <img src="@/assets/img/question-form/units-icon.svg" alt="units-icon" />
                  <input @input="clearError('plans_count')" @focus="activeField = 'plansСount'"
                    @blur="activeField = null" :placeholder="translations[lang].plansСount_placeholder" type="plansСount" name="plansСount" v-model="plansСount" data-question-form="plansСount" />
                </div>
              </label>

              <label class="styled-input styled-input--full" :class="{ 'has-text': activeField === 'question' }">
                <div class="styled-input__container">
                  <img src="@/assets/img/question-form/question-icon.svg" alt="question-icon" />
                  <input @input="clearError('question')" @focus="activeField = 'question'"
                    @blur="activeField = null" :placeholder="translations[lang].question_placeholder" type="text" name="question" v-model="question" data-question-form="question" />
                </div>
              </label>
            </div>

            <div v-if="lang === 'ru' && formSource === 'question'" class="modal-question-form__customer-type">
              <p class="modal-question-form__customer-type-description" v-text="translations[lang].introduce" />
              <div class="modal-question-form__customer-type-buttons">
                <div v-for="(item, index) in translations[lang].client" :key="index" class="modal-question-form__customer-type-buttons-item">
                  <input :id="item.value" :value="item.value" name="customerTypeQuestion" type="radio" v-model="customerType" :checked="item.checked" />
                  <label :for="item.value" v-text="item.title" />
                </div>
              </div>
            </div>

            <label :class="formSource === 'demo' ? 'styled-checkbox' : 'styled-checkbox--question'">
              <input id="input-checkbox" type="checkbox" name="agree" v-model="privacyPolicyAccept" checked />
              <div id="styled-checkbox" class="styled-checkbox--box">
                <img src="@/assets/img/check-icon-corall.svg" alt="check icon" />
              </div>
              <p class="text-checkbox" v-html="translations[lang].privacy" />
              <p id="error-text-checkbox" :class="formSource === 'demo' ? 'error-text-checkbox' : 'error-text-checkbox--question'">
                {{
                  !privacyPolicyAccept
                    ? (lang === 'ru'
                        ? 'Пожалуйста, подтвердите согласие на обработку данных'
                        : 'Please accept the privacy policy')
                    : ''
                }}
              </p>
            </label>

            <button :class="{ 'btn-send-preorder': isShowcasePreOrderForm }" :disabled="buttonDisabled" class="custom-button btn-send" id="submit" type="submit" v-text="formSource === 'demo' ? translations[lang].send : translations[lang].sendQuestion" @click="handleSubmit" />
          </form>

          <img class="modal-question-form-house" src="@/assets/img/house-in-form-modal-icon.svg" alt="house-icon" />
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { api } from '@/api';
import { triggeringYandexMetric } from '@/assets/js/yandex-metrics';
import { triggeringGoogleTagMetric } from '@/assets/js/google-tag-metrics';

const props = defineProps({
  lang: {
    type: String,
    default: 'en',
  },
  close: {
    default: () => null,
    type: Function,
  },
  openMessage: {
    default: () => null,
    type: Function,
  },
  title: {
    default: 'Get a Demo',
    type: String,
  },
  isShowcasePreOrderForm: {
    default: false,
    type: Boolean,
  },
  formSource: {
    type: String,
    default: 'default',
  },
});

const translations = ref({
  en: {
    client: [
      {
        checked: true,
        title: 'Company',
        value: 'company',
      },
      {
        title: 'Personal',
        value: 'personal',
      },
    ],
    name_placeholder: 'Name*',
    email_placeholder: 'Email*',
    companyUrl_placeholder: 'Company website',
    plansСount_placeholder: 'Number of Floor Plans',
    privacy: 'By clicking “Submit,” I agree to the <a class="link" href="/privacy-policy" target="_blank">processing of my personal data</a>.  Learn more in our <a class="link" href="/privacy-policy" target="_blank">Privacy Policy</a>',
    question_placeholder: 'Message',
    send: 'Submit Request',
    sendQuestion: 'Send',
    title: 'Get a Demo',
    titleQuestion: 'Ask your questions',
    subtitle: 'Get accurate <span class="subtitle-main">2D, 3D,</span> and <span class="subtitle-main">360° tours</span> for your property — delivered in just 24 hours.',
    subtitleQuestion: 'Our team helps you maximize AI\'s potential and find pricing for your needs',
  },
  ru: {
    client: [
      {
        checked: true,
        title: 'Для компании',
        value: 'company',
      },
      {
        title: 'Для себя',
        value: 'personal',
      },
    ],
    name_placeholder: 'Имя*',
    email_placeholder: 'Электронная почта*',
    introduce: 'Мне нужен ИИ Hart Estate:',
    companyUrl_placeholder: 'Веб-сайт компании',
    plansСount_placeholder: 'Количество планировок',
    privacy: 'Нажимая кнопку «Отправить», я даю согласие на <a class="link" href="/agreement" target="_blank">обработку персональных данных</a>. Узнать больше о <a class="link" href="/privacy-policy" target="_blank">политике конфиденциальности</a>',
    question_placeholder: 'Сообщение',
    send: 'Отправить запрос',
    sendQuestion: 'Отправить',
    title: 'Заявка на Демо',
    titleQuestion: 'Задайте ваш вопрос',
    subtitle: 'Точные <span class="subtitle-main">2D, 3D,</span> и <span class="subtitle-main">туры 360</span> для вашей недвижимости всего за 24 часа',
    subtitleQuestion: 'Расскажем о всех возможностях нашего ИИ',
  },
});
const name = ref('');
const email = ref('');
const question = ref('');
const companyUrl = ref('');
const plansСount = ref(null);
const privacyPolicyAccept = ref(true);
const customerType = ref('company');
const buttonDisabled = ref(false);
const errorMessage = ref({});
const selectedFindUs = ref('');
const activeField = ref(null);

const submitQuestion = (params, apiMethod) => {
  buttonDisabled.value = true;

  apiMethod(params)
    .then(() => {
      if (process.env.NODE_ENV === 'production') {
        try {
          triggeringYandexMetric.submitFormQuestion();
          triggeringGoogleTagMetric.submitFormQuestion();
        } catch (error) {
          console.error(error);
        }
      }
      props.close();
      props.openMessage();
    })
    .catch((err) => {
      if (err.response && err.response.data.errors) {
        errorMessage.value = { ...err.response.data.errors };
      }
    })
    .finally(() => {
      buttonDisabled.value = false;
    });
};

const handleSubmit = (e) => {
  e.stopPropagation();
  e.preventDefault();

  if (!privacyPolicyAccept.value) {
    return;
  }

  const errors = {};

  if (props.lang === 'en' && props.formSource === 'demo') {
    if (!name.value.trim()) errors.name = ['Please enter your name'];
    if (!email.value.trim()) errors.email = ['Please enter your work email'];
  }

  if (Object.keys(errors).length > 0) {
    errorMessage.value = errors;
    return;
  }

  const params = props.lang === 'ru'
    ? {
        email: email.value,
        question: question.value,
        customer_type: customerType.value,
      }
    : {
        name: name.value,
        email: email.value,
        ...(props.formSource === 'demo' ? {
          company_website: companyUrl.value,
          plans_count: Number(plansСount.value),
          find_us: selectedFindUs.value,
        } : {}),
        comment: question.value,
      };

  submitQuestion(params, props.lang === 'ru' ? api.askQuestion : api.askQuestionEn);
};

onMounted(() => {
  if (process.env.NODE_ENV === 'production') {
    try {
      triggeringYandexMetric.openFormQuestion();
      triggeringGoogleTagMetric.openFormQuestion();
    } catch (e) {
      console.error(e);
    }
  }
});

const clearError = (field) => {
  if (errorMessage.value[field]) {
    delete errorMessage.value[field];
  }
};
</script>
